var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.275024,
    width: 120,
    height: 120,
    rx: 60,
    fill: "#D1FADF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.482 37.2251L49.682 71.7751L40.182 61.6251C38.432 59.9751 35.682 59.8751 33.682 61.2751C31.732 62.7251 31.182 65.2751 32.382 67.3251L43.632 85.6251C44.732 87.3251 46.632 88.3751 48.782 88.3751C50.832 88.3751 52.782 87.3251 53.882 85.6251C55.682 83.2751 90.032 42.3251 90.032 42.3251C94.532 37.7251 89.082 33.6751 85.482 37.1751V37.2251Z",
    fill: "#12B76A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/Check-icon.16e4eacb6127a97a13a13a051319c0f7.svg";
export { ForwardRef as ReactComponent };